import React from 'react';
import PropTypes from 'prop-types';
import { LocalForm, Control } from 'react-redux-form';
import {
  FormGroup,
  Col,
  ControlLabel,
  Button,
  Collapse
} from 'react-bootstrap';

import { build as constants } from './../helpers';
import UserSelectorContainer from './../Containers/UserSelectorContainer';
import ConditionalComponent from './ConditionalComponent';
import SelectComponent from './SelectComponent';

export default class BuildSelectorComponent extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    isAuthenticated: PropTypes.bool.isRequired,
    isBaseline: PropTypes.bool,
    buildInfo: PropTypes.shape({
      buildType: PropTypes.string.isRequired,
      product: PropTypes.string.isRequired,
      buildNumber: PropTypes.number
    }).isRequired,
    onSubmit: PropTypes.func.isRequired,
    buildsByTypesAndProducts: PropTypes.object.isRequired,
    jobCountsByBuildId: PropTypes.object.isRequired,
    annotationsFeedbackScoresByBuildIds: PropTypes.object.isRequired
  };

  constructor() {
    super();
    this.state = { buildType: '' };
  }

  componentDidMount() {
    this.setState({
      buildType: this.props.buildInfo.buildType.length > 0 ?
        this.props.buildInfo.buildType :
        constants.LATEST_RELEASE
    });
  }

  getProductNameOptions = (buildType) => {
    const options = constants.BUILD_TYPE_VALUES[buildType];
    return options ? options : [];
  };

  isDisabled = (buildType) => {
    const disabledTypes = [
      constants.LATEST_BY_IMAGE,
      constants.LATEST_RELEASE,
      constants.EXPECTED
    ];
    return disabledTypes.find(t => t === buildType) !== undefined;
  }

  getProductionProductOptions = (build, product) => {
    if (!constants.PRODUCTS_BY_PROD[product]) {
      return [];
    }

    const builds = build[constants.getProdNameByProductName(product)];
    return builds ? builds : [];
  }

  getPrebuildOrTopicProductOptions = (build, product) => build[product] ?
    build[product] :
    []

  getBuildOptions = (buildType, product) => {
    let builds = [];
    if (this.props.buildsByTypesAndProducts[buildType] !== undefined) {
      const byProduct = this.props.buildsByTypesAndProducts[buildType];

      switch (buildType) {
        case constants.LATEST_RELEASE:
        case constants.BUILD_PRODUCTION:
          builds = this.getProductionProductOptions(byProduct, product);
          break;
        case constants.BUILD_PREBUILD:
        case constants.BUILD_TOPIC:
          builds = this.getPrebuildOrTopicProductOptions(byProduct, product);
          break;
      }
    }
    return builds
      .sort((a, b) => b.build - a.build)
      .map(b => {
        const tests = this.props.jobCountsByBuildId[b.id];
        return {
          text: b.build + '  (tests: ' + (tests ? tests : 0) +
            ', files: ' + b.files +
            ', votes: +' + (this.props.annotationsFeedbackScoresByBuildIds[b.id] ?
            (this.props.annotationsFeedbackScoresByBuildIds[b.id]['upVotes'] +
            '/-' + this.props.annotationsFeedbackScoresByBuildIds[b.id]['downVotes']) :
            '0/-0') + ')',
          value: b.build
        };
      });
  }

  getMaxBuildNumber(model) {
    const builds = this.getBuildOptions(model.buildType, model.product);
    return builds && builds.length > 0 ? builds[0].value : 0;
  }

  render() {
    const {
      title,
      isAuthenticated,
      isBaseline,
      onSubmit,
      buildInfo
    } = this.props;
    const buildTypeOptions = constants.getBuildTypeOptions(isBaseline);
    const needLogin = !isAuthenticated &&
                      (this.state.buildType === 'Expected' ||
                       (!isBaseline &&
                        (!buildInfo || buildInfo.buildType === 'Expected')));
    const products = this.getProductNameOptions(buildTypeOptions[0]);
    const initialState = {
      buildType: buildInfo.buildType.length > 0 ?
        buildInfo.buildType :
        constants.LATEST_RELEASE,
      product: buildInfo.product.length > 0 ?
        buildInfo.product :
        products.length > 0 ? products[0].value : '',
      buildNumber: buildInfo.buildNumber
    };

    const onPreSubmit = (model) => {
      if (model.buildNumber === 0) {
        model.buildNumber = this.getMaxBuildNumber(model);
      }

      onSubmit(model);
    };

    return (
      <div>
        <LocalForm
          className="build-selector-form"
          onSubmit={onPreSubmit}
          onChange={model => this.setState({ buildType: model.buildType })}
          initialState={initialState}
        >
          <ConditionalComponent condition={title !== undefined && title.length > 0}>
            <legend>{title}</legend>
          </ConditionalComponent>
          <FormGroup>
            <Col md={4}>
              <ControlLabel>Build Type</ControlLabel>
              <Control.custom
                model="."
                component={SelectComponent}
                className="build-type-input form-control"
                style={{ marginRight: '10px' }}
                mapProps={({ modelValue, onChange }) => {
                  return {
                    options: buildTypeOptions,
                    selected: modelValue.buildType,
                    onChange: d => {
                      const options = this.getProductNameOptions(d);
                      const model = {
                        ...modelValue,
                        buildType: d,
                        product: options.length > 0 ? options[0].value : ''
                      };
                      model.buildNumber = this.getMaxBuildNumber(model);
                      onChange(model);
                    }
                  };
                }}
              />
            </Col>
            <Col md={2}>
              <ControlLabel>Product Name</ControlLabel>
              <Control.custom
                model="."
                component={SelectComponent}
                className="product-input form-control"
                style={{ marginRight: '10px' }}
                mapProps={({ modelValue, onChange }) => {
                  const options = this.getProductNameOptions(modelValue.buildType);
                  return {
                    options,
                    disabled: options.length === 0,
                    selected: modelValue.product,
                    onChange: d => {
                      const model = {
                        ...modelValue,
                        product: d
                      };
                      model.buildNumber = this.getMaxBuildNumber(model);
                      onChange(model);
                    }
                  };
                }}
              />
            </Col>
            <Col md={4}>
              <ControlLabel>Build #</ControlLabel>
              <Control.custom
                model="."
                component={SelectComponent}
                className="build-number-input form-control"
                style={{ marginRight: '10px' }}
                mapProps={({ modelValue, onChange }) => {
                  return {
                    options:
                      this.getBuildOptions(modelValue.buildType, modelValue.product),
                    selected: modelValue.buildNumber,
                    onChange: d => {
                      const model = {
                        ...modelValue,
                        buildNumber: +d
                      };
                      onChange(model);
                    },
                    disabled: this.isDisabled(modelValue.buildType)
                  };
                }}
                placeholder="Latest"
              />
            </Col>
            <Col md={2}>
              <ControlLabel>&nbsp;</ControlLabel>
              <Button
                className="form-control"
                type="submit"
                disabled={needLogin}
              >
                Select
              </Button>
            </Col>
          </FormGroup>
        </LocalForm>
        <Collapse in={needLogin}>
          <div>
            <UserSelectorContainer />
          </div>
        </Collapse>
        {
          isBaseline && isAuthenticated &&
          <ControlLabel style={{ 'color': 'green', padding: '15px 0 0 15px' }}>
            Logged in
          </ControlLabel>
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// src/Components/BuildSelectorComponent.jsx